module.exports = __webpack_public_path__ + "img/female_B_02.172e8bb0.png";